import React from "react";
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import Seo from '../../components/Seo';

const Homepage = () => {
  return (
    <>
      <Seo
        title="Skyline VFX - Digital Matte Painting & Concept Art"
        description="Portfolio of Lee Munday - Digital Matte Painter and Concept Artist for Film & Television VFX."
      />
      <div className="min-h-screen text-white">
        <Header />
        <main>
          <HeroSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Homepage;
